import { createAction } from 'store/utils';

const namespaceAction = createAction('/APP');

const updateCustomerSearchKey = namespaceAction('UPDATE_CUSTOMER_SEARCH_KEY');
const updateCustomerSearchTerm = namespaceAction('UPDATE_CUSTOMER_SEARCH_TERM');
const updateItemSearchKey = namespaceAction('UPDATE_ITEM_SEARCH_KEY');
const updateItemSearchTerm = namespaceAction('UPDATE_ITEM_SEARCH_TERM');
const updateItems = namespaceAction('UPDATE_ITEMS');
const updateCollectionName = namespaceAction('UPDATE_COLLECTION_NAME');

const updateUserID = namespaceAction('UPDATE_USER_ID');
const updateProductID = namespaceAction('UPDATE_PRODUCT_ID');

const updateLang = namespaceAction('UPDATE_LANG');

const updateCurrentPage = namespaceAction('UPDATE_CURRENT_PAGE');

const initialiseState = namespaceAction('INITIALISE_STATE');

const updateViewOption = namespaceAction('UPDATE_VIEW_OPTION');

const updateClassName = namespaceAction('UPDATE_CLASSNAME');

const updateItemsNumber = namespaceAction('UPDATE_ITEMS_NUMBER');

const openCollectionModal = namespaceAction('OPEN_COLLECTION_MODAL')

const updateEmail = namespaceAction('UPDATE_EMAIL')

export {
  updateCustomerSearchKey,
  updateCustomerSearchTerm,
  updateItemSearchKey,
  updateItemSearchTerm,
  updateUserID,
  updateProductID,
  updateLang,
  initialiseState,
  updateItems,
  updateCurrentPage,
  updateViewOption,
  updateClassName,
  updateItemsNumber,
  updateCollectionName,
  openCollectionModal,
  updateEmail
};



// WEBPACK FOOTER //
// ./src/model/actions.js